import React from "react";
import { Mail, MailOpen, Paperclip } from "lucide-react";
import { Badge, STATUS, fmtDate } from "./mailUtils";

const MailList = ({ messages, folder, selectedId, onSelect }) => {
  if (messages.length === 0) {
    return (
      <p className="text-sm text-neutral-500 p-4" data-testid="mail-list-empty">
        {folder === "inbox" ? "Aucun email reçu. Cliquez sur « Actualiser » pour relever la boîte." : "Aucun email envoyé depuis le CRM."}
      </p>
    );
  }
  return (
    <ul className="divide-y divide-neutral-100 max-h-[70vh] overflow-y-auto" data-testid="mail-list">
      {messages.map((m) => {
        const active = m.id === selectedId;
        const unread = folder === "inbox" && !m.read;
        return (
          <li key={m.id}>
            <button
              onClick={() => onSelect(m.id)}
              data-testid={`mail-item-${m.id}`}
              className={`w-full text-left px-4 py-3 transition-colors ${active ? "bg-brand/5 border-l-2 border-brand" : "hover:bg-neutral-50 border-l-2 border-transparent"}`}
            >
              <div className="flex items-center gap-2">
                {unread ? <Mail size={14} className="text-brand shrink-0" /> : <MailOpen size={14} className="text-neutral-400 shrink-0" />}
                <span className={`text-sm truncate ${unread ? "font-bold text-neutral-900" : "text-neutral-700"}`}>
                  {folder === "inbox" ? (m.from_name || m.from_email) : `À : ${m.to}`}
                </span>
                <span className="ml-auto text-[11px] text-neutral-400 shrink-0">{fmtDate(m.date)}</span>
              </div>
              <p className={`text-sm truncate mt-0.5 ${unread ? "font-semibold text-neutral-800" : "text-neutral-600"}`}>{m.subject}</p>
              <div className="flex items-center gap-2 mt-1">
                <p className="text-xs text-neutral-400 truncate flex-1">{m.preview}</p>
                {m.attachments?.length > 0 && <Paperclip size={12} className="text-neutral-400" />}
                {folder === "inbox" && m.agent_status && m.agent_status !== "nouveau" && <Badge map={STATUS} value={m.agent_status} />}
                {folder === "sent" && m.status === "error" && <span className="text-[11px] text-red-600 font-semibold">Échec</span>}
              </div>
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default MailList;
